import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import { ViewTag } from '@insights_module/components/integrations/ViewTag';
import { CloseIcon } from '@icons/CloseIcon';
import { Button } from '@components/Button';
import { SegmentCreatorProvider } from '@insights_module/context/SegmentCreatorContext';
import { IntegrationType } from '@insights_module/types/Integrations';
import { useIntegrationsContext } from '@insights_module/context/IntegrationsContext';
import { useFeatureFlag, FEATURE_FLAG } from '@auth_module/hooks/useFeatureFlag';
import { Modal } from '@components/Modal';

const Container = tw.div`relative w-full max-w-[1300px] border border-solid border-gray-1 rounded-lg shadow-modal my-8 lg:min-w-[1200px] mx-auto`;
const Header = tw.div`w-full bg-neutral-background px-6 py-2 border-b border-solid border-gray-1 flex items-center justify-between rounded-t-lg`;
const Title = tw.span`text-sm text-text-and-icon text-left font-semibold`;
const ModalButton = tw(
  Button.Primary
)`text-xs leading-none p-0 w-auto h-[28px] border border-solid border-none align-middle shadow-none`;

export const ViewTagModal = ({ type }: { type: IntegrationType }): JSX.Element | null => {
  const { t } = useTranslation();
  const { isEditTagModalOpen, setIsEditTagModalOpen, setType } = useIntegrationsContext();
  const { isEnabled: isFlightpathEnabled } = useFeatureFlag(
    FEATURE_FLAG.MEGAPHONE_FLIGHTPATH_INTEGRATION
  );

  useEffect(() => {
    setType(type);
  }, []);

  if (!isEditTagModalOpen) {
    return null;
  }

  return (
    <Modal onClose={() => setIsEditTagModalOpen(false)}>
      <Container css={[type === 'megaphone' && isFlightpathEnabled && tw`w-full`]}>
        <Header>
          <Title>{t('insights.integrations.megaphone.view_tag_modal.title')}</Title>
          <ModalButton tw='bg-transparent w-[28px]' onClick={() => setIsEditTagModalOpen(false)}>
            <CloseIcon tw='fill-text-and-icon' />
          </ModalButton>
        </Header>

        <SegmentCreatorProvider>
          <ViewTag type={type} />
        </SegmentCreatorProvider>
      </Container>
    </Modal>
  );
};
